import { createContext, useContext } from 'react';

export interface VariantTableConfidenceLevelContextType {
  isConfidenceLevelToggleActive: boolean;
}

const VariantTableConfidenceLevelContextState = {
  isConfidenceLevelToggleActive: false,
};

export const VariantTableConfidenceLevelContext =
  createContext<VariantTableConfidenceLevelContextType>(VariantTableConfidenceLevelContextState);

export const useVariantTableConfidenceLevelContext = () =>
  useContext(VariantTableConfidenceLevelContext);
